module.exports = __webpack_public_path__ + "static/media/Old-dashboard-design.2475d85e.png";